import { encrypt } from './encryption';

import { API } from '../interceptors/axios';

export const fetchAuth = async () => {
    try {        
        // Encrypt user data and service credentials
        const encryptedData = encrypt(process.env.REACT_APP_USER);
        const encryptedService = encrypt(process.env.REACT_APP_SERVICE_NAME);
        const encryptedKey = encrypt(process.env.REACT_APP_SERVICE_KEY);
        
        const res = await API.post(
            `${process.env.REACT_APP_API_URL}/options/`,
            { data: encryptedData },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'x-service-name': encryptedService,
                    'x-service-key': encryptedKey
                },
                withCredentials: true
            }
        );

        if (res.data) {
            localStorage.setItem("token", res.data);
            return res.data;
        }

        throw new Error('No token received');
    } catch (err) {
        console.error('Authentication failed:', err);
        if (err.response?.status === 403) {
            window.location.href = '/login';
        }
        throw err;
    }
}